import React from "react"
import ReactDOM from 'react-dom';

class AddButton extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data || null,
      new_button: typeof this.props.new_button != 'undefined' ? this.props.new_button : true,
    };

    this.onAdd = this.onAdd.bind(this);
  }

  componentDidMount() {
    $(this.refs.button).popover({
      container: 'body',
      content: () => {
        // popover-body
        // ReactDOM.render(
        //   this.renderPopoverContent(),
        //   this.refs.button
        // );
        // return this.renderPopoverContent();
        return''
      },
      // html: true,
      placement: function (tip, element) {
        var offset = $(element).offset();
        var height = $(document).outerHeight();
        var width = $(document).outerWidth();
        var vert = 0.5 * height - offset.top;
        var vertPlacement = vert > 0 ? 'bottom' : 'top';
        var horiz = 0.5 * width - offset.left;
        var horizPlacement = horiz > 0 ? 'right' : 'left';
        var placement = Math.abs(horiz) > Math.abs(vert) ? horizPlacement : vertPlacement;
        return placement;
      },
      react: true,
    }).on('hidden.bs.popover', () => {

      this.load();
    }).on('shown.bs.popover', () => {
      var self = this;
      ReactDOM.render(
        this.renderPopoverContent(),
        document.getElementsByClassName("popover-body")[0]
      );
      // hide popover on click outside
      $(document.body).on('click.popover', function (e) {
        if ($(e.target).parents('.popover-content').length == 0) {
          var removed = ReactDOM.unmountComponentAtNode(document.getElementsByClassName("popover-body")[0])
          $(self.refs.button).popover('hide');
        }
      });
    }).on('hide.bs.popover', () => {
      var removed = ReactDOM.unmountComponentAtNode(document.getElementsByClassName("popover-body")[0])
      $(document.body).off('click.popover');
    });

    this.load();
  }

  componentWillUnmount() {
    $(this.refs.button).popover('dispose');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props && !this.arraysEqual(prevProps.ids, this.props.ids)) {
      this.load(this.props);
    }
    if (this.props && this.props.room_type && nextProps.room_type && this.props.room_type.id != nextProps.room_type.id) {
      this.load(this.props);
    }
  }

  arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  render() {
    return (
      <div className={`add-button${this.props.reply ? " addReply" : ""}`} ref="self">
        <button disabled={this.props.disabled} ref="button" type="button" className={this.props.buttonClasses || "btn btn-primary btn-xs"}>{this.props.text ? this.props.text : I18n.t('add_model', { model: I18n.t(this.props.model.toLowerCase()) })}</button>
        {this.props.new_in_modal ? <a ref="newInModal" data-fullscreen="true" data-nested="true" href={this.props.new_in_modal} className="modal-iframe" style={{ display: 'none' }}></a> : null}
      </div>
    );
  }

  renderPopoverContent() {
    if (this.props.model === "User") {
      return (
        <div className="content">
          {this.renderData()}
        </div>
      );
    } else
    return (
      <div className="content">
        {
          this.state.new_button
          ?
          <button type="button" className="btn btn-block btn-primary" onClick={this.onAdd.bind(null, {})}>{this.props.create_new_text ? this.props.create_new_text : I18n.t('create_new_model', {model: I18n.t(this.props.model.toLowerCase())})}</button>
          :
          null
        }
        {this.renderData()}
      </div>
    );
  }

  addGroupNameToItem(item) {
    var groupName = ""
    this.props.all_field_groups.map((group) => {
      if(item.field_group_id == group.id) {
        groupName = group.name
      }
    })
    item.field_group_name = groupName
  }

  renderData() {
    if (this.state.data) {
      if (this.state.data.length) {
        var items = this.state.data.map((item) => {
          // return(`<li key=${item.id}>${item.id}</li>`)
          if(item.field) {
            if(this.props.all_field_groups) {
              this.addGroupNameToItem(item)
            }
            if(item.field_group_name) {
              return <li key={item.id}><a href="#" onClick={this.onAdd.bind(null, item)}>{`${item.field} (${item.field_group_name})`}</a></li>
            } else {
              return <li key={item.id}><a href="#" onClick={this.onAdd.bind(null, item)}>{`${item.field} `} <em>{`(${I18n.t('none')})`}</em></a></li>
            }
          } else if(item.body) {
            return <li key={item.id}><a href="#" onClick={this.onAdd.bind(null, item)}>{`${item.code} `} <em>{`(${item.name})`}</em></a></li>
          } else {
            item.full_name = item.name ? item.name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') : `${item.first_name} ${item.last_name}`
            return <li key={item.id}><a href="#" onClick={this.onAdd.bind(null, item)}>{this.props.column ? item[this.props.column] : item.full_name}</a></li>
          }
        });
        return (
          <div className="add-button-results">
            <ul className="data">
              {items}
            </ul>
          </div>
        );
      } else {
        return <div className="text-center"><span className="none">{I18n.t('none')}</span></div>;
      }
    } else {
      return (
        <div className="add-button-results">
          <div className="spinner" />
        </div>
      );
    }
  }

  load(props) {
    var props = props || this.props;
    $.ajax({
      type: 'POST',
      url: '/admin/add-button/' + props.model,
      data: this.params(props)
    }).done((data) => {
      if (this.refs.self) { // make sure the component is still loaded
        this.setState({ data: data });
      }
    });
  }

  params(props) {
    var params = '';

    if (props.column) {
      params += '&column=' + props.column;
    }

    if (props.ids && props.ids.length) {
      params += '&ids=' + props.ids;
    }

    if (props.room_type) {
      params += '&room_type_id=' + props.room_type.id;
    }

    if (typeof props.is_automatically_applied !== 'undefined') {
      params += '&is_automatically_applied=' + props.is_automatically_applied;
    }

    if (props.reservation_segment) {
      params += '&reservation_segment_id=' + props.reservation_segment.id;
    }

    if (props.view_type) {
      params += '&view_type=' + props.view_type;
    }

    return params;
  }

  onAdd(json, event) {
    event.stopPropagation();
    event.preventDefault();
    if (json && !json.id && this.props.new_in_modal) {
      $(this.refs.newInModal).trigger('click');
    } else {
      if (typeof this.props.onAdd == 'function') {
        this.props.onAdd(json);
      }
    }
    $(this.refs.button).popover('hide');
  }

};

export default AddButton
